module.exports = __webpack_public_path__ + "img/other.80b022f5.svg";